import{
    apiRequest,
    pejabatPenetapDetail,
    pejabatPenetapUpdate,
    employeeList,
    polaKerjaList
} from "../../../../../services/adapters/kepegawaian/pejabatPenetapService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pejabatPenetapDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", pejabatPenetapUpdate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }
    fetchPolaKerja = async (query) => {
        return await apiRequest("get", polaKerjaList, {
            params: query
        }, true)
    }
}

export default UpdateRepository